import ENDPOINTS from './index';

export interface SendEmailCodeRequest {
  email: string;
  turnstile: string;
}

export interface SendEmailCodeResponse {
  message: string;
  cooldownSeconds?: number;
}

export interface VerifyEmailCodeRequest {
  email: string;
  code: string;
}

export interface VerifyEmailCodeResponse {
  message: string;
  emailVerified: boolean;
}

export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

/**
 * Send email verification code
 */
export async function sendEmailVerificationCode(
  request: SendEmailCodeRequest
): Promise<ApiResponse<SendEmailCodeResponse>> {
  const response = await fetch(ENDPOINTS.sendEmailBondCode, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Required for HTTP-only cookie auth
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error('Failed to send verification code');
  }

  return response.json();
}

/**
 * Verify email with code
 */
export async function verifyEmailCode(
  request: VerifyEmailCodeRequest
): Promise<ApiResponse<VerifyEmailCodeResponse>> {
  const response = await fetch(ENDPOINTS.verifyEmailBondCode, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Required for HTTP-only cookie auth
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error('Failed to verify code');
  }

  return response.json();
}
